import { CircularProgress, styled } from '@mui/material';

const CustomLoading = styled(CircularProgress)({
  color: '#0A7AFF',
});

export default CustomLoading;
